const toNumber = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

export const calculateEffortCost = (effort, settings) => {
  const frequency = toNumber(effort.freq);
  const time = toNumber(effort.time);
  const weeksPerYear = toNumber(settings.weeksPerYear);
  const hourlyRate = toNumber(settings.hourlyRate);
  let annualOccurrences = frequency;

  if (effort.freqUnit === 'day') {
    annualOccurrences = frequency * 5 * weeksPerYear;
  } else if (effort.freqUnit === 'week') {
    annualOccurrences = frequency * weeksPerYear;
  } else if (effort.freqUnit === 'month') {
    annualOccurrences = frequency * 12;
  }

  const hoursPerOccurrence =
    effort.timeUnit === 'min' ? time / 60 : time;

  return annualOccurrences * hoursPerOccurrence * hourlyRate;
};

export const calculateProblemTotal = (problem, settings) => {
  const cost = problem.efforts.reduce(
    (sum, effort) => sum + calculateEffortCost(effort, settings),
    0
  );

  return { cost };
};